<template>
  <div>
    <div class="vtl">
      <div v-if="model.name !== 'root'">
        <div
          :id="model.id"
          style="position: relative"
          :class="treeNodeClass"
          @click.stop="click"
        >
          <div style="display: inline-flex; width: 100%">
            <span
              v-if="model.children && model.children.length > 0"
              class="vtl-caret vtl-is-small"
              style="position: absolute"
            >
              <i
                class="vtl-icon"
                :class="caretClass"
                @click.prevent.stop="toggle"
              />
            </span>
            <div class="vtl-node-content" style="width: calc(100% - 300px)">
              <div
                v-if="model.improvementScore"
                class="dot"
                :class="{
                  'dot-outline': model.improvementScore === 1,
                  'dot-filled': model.improvementScore === 2,
                }"
              />
              <span :class="isNotParent">
                <b>{{ model.evaluation_administrator_node_nomenclature }}</b>
                <b v-if="level <= 2">
                  {{ model.evaluation_administrator_node_requirementName }}
                </b>
              </span>
              <span v-if="level > 2" :class="isNotParent">
                {{ model.evaluation_administrator_node_requirementName }}
              </span>
              <div
                v-if="!model.children || model.children.length === 0"
                class="evidence-indicator"
              >
                {{
                  getEvidenceIndicators(
                    model.evaluation_administrator_node_editRequirement_requireEvidences
                  )
                }}
              </div>
            </div>
            <div>
              <div style="text-align: center; width: 100px">
                <span
                  v-if="model.children && model.children.length > 0"
                  :class="getEvidenceIndicatorsColors(model.evidencesScore)"
                  >{{ model.evaluation_progress || "0" }} of
                  <span v-if="model.children">{{
                    model.children.length
                  }}</span></span
                >
                <span
                  v-if="!model.children || model.children.length === 0"
                  :class="getEvidenceIndicatorsColors(model.evidencesScore)"
                >
                  <span v-if="model.comments && model.comments.length > 0">
                    <span>
                      <img
                        src="../../../../assets/images/comment_icon.svg"
                        style="width: 20px; height: 20px"
                      />
                    </span>
                  </span>
                </span>
              </div>
            </div>
            <div>
              <div
                v-if="!model.children || model.children.length === 0"
                :key="model.evaluation_status"
                style="text-align: center; width: 100px"
              >
                {{ $t(labels[model.evaluation_status]) }}
              </div>
              <div
                v-if="model.children && model.children.length > 0"
                :key="model.evaluation_status"
                style="text-align: center; width: 100px"
              >
                {{ model.evaluation_status || "0" }} %
              </div>
            </div>
            <div>
              <div style="text-align: center; width: 100px">
                {{ model.evaluation_last_updated }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-show="model.name === 'root' || expanded"
        v-if="isFolder"
        :class="{ 'vtl-tree-margin': model.name !== 'root' }"
      >
        <evaluation-evaluate-tree-list
          v-for="model in model.children"
          :key="model.id"
          :last-evaluated="lastEvaluated"
          :default-expanded="defaultExpanded"
          :model="model"
          :level="level + 1"
          :evaluation-id="evaluationId"
        />
      </div>
      <b-modal
        id="modalInfo"
        v-model="showModal"
        modal-class="modalInfo"
        :title="'Delete '"
      >
        {{ $t("label_evaluation_delete_message") }}
        <b> {{ model.evaluation_administrator_node_requirementName }}</b>
        <div slot="modal-footer" class="w-100" style="text-align: right">
          <b-btn variant="primary" @click="hideModal()">
            {{ $t("label_evaluation_cancel_button") }}
          </b-btn>
          <b-btn variant="primary" @click="delNode()">
            {{ $t("label_evaluation_create_button") }}
          </b-btn>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
import {
  addHandler,
  removeHandler,
} from "../../../../utils/vue-tree-list/tools";
import { mapGetters } from "vuex";
import axios from "axios";

export default {
  name: "EvaluationEvaluateTreeList",
  props: {
    level: {
      type: Number,
      default: 0,
    },
    lastEvaluated: {
      type: Number,
      default: 0,
    },
    model: {
      type: Object,
    },
    defaultExpanded: {
      type: Boolean,
      default: false,
    },
    evaluationId: {
      type: String,
      default: "0",
    },
  },
  data: function () {
    return {
      isHover: false,
      editable: false,
      isDragEnterUp: false,
      isDragEnterBottom: false,
      isDragEnterNode: false,
      expanded: this.defaultExpanded,
      showModal: false,
      evidencesScore: -1,
      totalEvidences: 0,
      labels: {
        0: "label_evaluation_not achieved",
        50: "label_evaluation_partially achieved",
        75: "label_evaluation_close to be achieved",
        100: "label_evaluation_achieved",
      },
    };
  },
  computed: {
    itemIconClass() {
      return this.model.isLeaf ? "vtl-icon-file" : "vtl-icon-folder";
    },
    caretClass() {
      return this.expanded ? "vtl-icon-caret-down" : "vtl-icon-caret-right";
    },

    isNotParent() {
      return typeof this.model.children === "undefined"
        ? "selectable underlined"
        : "";
    },

    isFolder() {
      return this.model.children && this.model.children.length;
    },

    treeNodeClass() {
      const {
        model: { dragDisabled, disabled },
      } = this;

      return {
        "vtl-tree-node": true,
        "vtl-drag-disabled": dragDisabled,
        "vtl-disabled": disabled,
        "hover-activated":
          !this.model.children || this.model.children.length === 0,
      };
    },
  },
  mounted() {
    const vm = this;
    addHandler(window, "keyup", function (e) {
      // click enter
      if (e.keyCode === 13 && vm.editable) {
        vm.editable = false;
      }
    });
  },
  beforeDestroy() {
    removeHandler(window, "keyup");
  },
  methods: {
    getEvidences: async function () {
      if (
        this.model
          .evaluation_administrator_node_editRequirement_requireEvidences
      ) {
        if (
          !this.model.evidences ||
          typeof this.model.evidences === "undefined"
        ) {
          this.model.evidences = [];
        }
        await axios
          .get(`/Evidences/${this.evaluationId}/${this.model.id}`)
          .then((response) => {
            this.model.ownedEvidences = response.data.owned;
            this.model.linkedEvidences = response.data.linked;
            var total = 0;
            if (response.data.owned) {
              total += response.data.owned.length;
            }
            if (response.data.linked) {
              total += response.data.linked.length;
            }
            if (this.model.evidences && this.model.evidences.comments) {
              total += this.model.evidences.comments.length;
            }
            this.totalEvidences = total;
            this.evidencesScore = this.determinateEvidenceScore();
          });
      }
    },
    determinateEvidenceScore() {
      var score = 0;

      if (this.model.evidences) {
        if (this.model.evidences.comments) {
          score = 1;
        }
      }
      if (this.model.ownedEvidences) {
        if (this.model.ownedEvidences.length > 0) {
          score = 3;
        }
      }
      if (this.model.linkedEvidences) {
        if (this.model.linkedEvidences.length > 0) {
          score = 2;
        }
      }
      return score;
    },
    extendStatus(eva) {
      var result = { status: "", statusValue: 5, evidencesQnt: 0, score: 0 };
      var temp = {};
      if (eva.children) {
        for (var i = 0; i < eva.children.length; i++) {
          temp = this.extendStatus(eva.children[i]);
          if (temp.statusValue <= result.statusValue) {
            result.statusValue = temp.statusValue;
            result.status = temp.status;
          }
          if (temp.score > result.score) {
            result.score = temp.score;
          }
          result.evidencesQnt += temp.evidencesQnt;
        }
        return result;
      } else if (!eva.children || eva.children.length == 0) {
        var total = 0;
        if (eva.evidences && eva.evidences.comments) {
          total += eva.evidences.comments.length;
          if (eva.evidences.comments.length > 0) {
            result.score = 1;
          }
        }
        if (eva.ownedEvidences) {
          total += eva.ownedEvidences.length;
          if (eva.ownedEvidences.length > 0) {
            result.score = 3;
          }
        }
        if (eva.linkedEvidences) {
          total += eva.linkedEvidences.length;
          if (eva.linkedEvidences.length > 0) {
            result.score = 2;
          }
        }

        result.evidencesQnt = total;
        temp = this.getStatusValue(
          eva.evaluation_administrator_node_editRequirement_evidencesReady
        );
        result.statusValue = temp.value;
        result.status = temp.label;
        return result;
      }
    },
    getStatusValue(status) {
      switch (status) {
        case "label_evaluation_evidencesRequested_status_ready":
          return {
            label: "label_evaluation_evidencesRequested_status_ready",
            value: 3,
          };
        case "label_evaluation_evidencesRequested_status_pending":
          return {
            label: "label_evaluation_evidencesRequested_status_pending",
            value: 2,
          };
        case "label_evaluation_evidencesRequested_status_inProgress":
          return {
            label: "label_evaluation_evidencesRequested_status_inProgress",
            value: 1,
          };
        case "label_evaluation_evidencesRequested_status_resubmit":
          return {
            label: "label_evaluation_evidencesRequested_status_resubmit",
            value: 0,
          };
        default:
          return { label: "", value: -1 };
      }
    },
    getEvidenceIndicatorsColors(evidenceScore) {
      switch (evidenceScore) {
        case 2:
          return { "evidences-indicator-blue": true };
        case 3:
          return { "evidences-indicator-green": true };
        case 1:
          return { "evidences-indicator-outline": true };
        default:
          return {};
      }
    },
    getEvidenceIndicators(requireEvidences) {
      if (requireEvidences) {
        if ([2, 3].includes(this.model.evidencesScore)) {
          return `${this.$t(
            "label_evaluation_administrator_node_matrix_evidence"
          )} ${this.$t("label_evaluation_evidencesRequested_status_file")}`;
        }
        if (this.model.evidencesScore === 1) {
          return `${this.$t(
            "label_evaluation_administrator_node_matrix_evidence"
          )} ${this.$t("label_evaluation_evidencesRequested_status_note")}`;
        }
        if (!this.model.evidencesScore) {
          return `${this.$t(
            "label_evaluation_administrator_node_matrix_evidence"
          )} ${this.$t("label_evaluation_evidencesRequested_status_pending")}`;
        }
      }
      return "";
    },
    commentsHaveTagOfPossibleOpportunities(model) {
      if (model.children && model.children.length) {
        let hasGeneralOp = 0;
        model.children.forEach((child) => {
          hasGeneralOp =
            hasGeneralOp + this.commentsHaveTagOfPossibleOpportunities(child);
        });
        if (hasGeneralOp) {
          return hasGeneralOp;
        }
      }
      if (!model.comments || !model.comments.length) {
        return 0;
      }
      return model.comments.filter((comment) => comment.opportunity === true)
        .length > 0
        ? 1
        : 0;
    },
    lastEvaluatedInChildren(node) {
      let shouldExpand = false;
      if (node.children && node.children.length > 0) {
        node.children.map((child) => {
          if (child.children && child.children.length > 0) {
            shouldExpand = shouldExpand || this.lastEvaluatedInChildren(child);
          } else {
            if (child.id === this.lastEvaluated) {
              shouldExpand = true;
            }
          }
        });
      }
      return shouldExpand;
    },
    showModalF() {
      this.showModal = true;
    },
    hideModal() {
      this.showModal = false;
    },
    toggle() {
      if (this.isFolder) {
        this.expanded = !this.expanded;
      }
    },
    async click() {
      if (!this.model.children || this.model.children.length === 0) {
        var node = this.getRootNodeAndPath();
        await this.$store.dispatch("getEvaluation", {
          requirementId: this.model.id,
          isOrganization: false,
        });
        node.node.$emit("updatePath", node.path);
      }
    },
    getRootNode() {
      var node = this.$parent;
      while (node._props.model.name !== "root") {
        node = node.$parent;
      }
      return node;
    },
    getRootNodeAndPath() {
      var node = this.$parent;
      var path = [];
      while (node._props.model.name !== "root") {
        path.push({
          name: node._props.model.evaluation_administrator_node_requirementName,
          nom: node._props.model.evaluation_administrator_node_nomenclature,
        });
        node = node.$parent;
      }
      return { node, path };
    },
  },
};
</script>
<style lang="scss" scoped>
.selectable:hover {
  text-decoration-line: underline;
}

.underlined:hover {
  cursor: pointer;
}

h4 {
  font-size: 1.3rem;
  text-transform: uppercase;
}

@font-face {
  font-family: "icomoon";
  src: url("../../../../utils/vue-tree-list/fonts/icomoon.eot");
  src: url("../../../../utils/vue-tree-list/fonts/icomoon.eot")
      format("embedded-opentype"),
    url("../../../../utils/vue-tree-list/fonts/icomoon.ttf") format("truetype"),
    url("../../../../utils/vue-tree-list/fonts/icomoon.woff") format("woff"),
    url("../../../../utils/vue-tree-list/fonts/icomoon.svg") format("svg");
  font-weight: normal;
  font-style: normal;
}

.vtl-icon {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "icomoon" !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  &.vtl-menu-icon {
    margin-right: 4px;

    &:hover {
      color: inherit;
    }
  }

  &:hover {
    color: blue;
  }
}

.vtl-icon-file:before {
  content: "\e906";
}

.vtl-icon-folder:before {
  content: "\e907";
}

.vtl-icon-caret-down:before {
  content: "\e901";
}

.vtl-icon-caret-right:before {
  content: "\e900";
}

.vtl-icon-edit:before {
  content: "\e902";
}

.vtl-icon-folder-plus-e:before {
  content: "\e903";
}

.vtl-icon-plus:before {
  content: "\e904";
}

.vtl-icon-trash:before {
  content: "\e905";
}

.vtl-border {
  height: 5px;

  &.vtl-up {
    margin-top: -5px;
    background-color: transparent;
  }

  &.vtl-bottom {
    background-color: transparent;
  }

  &.vtl-active {
    border-bottom: 3px dashed blue;
    /*background-color: blue;*/
  }
}

.hover-activated:hover {
  background-color: #f0f0f0;
}

.vtl-tree-node {
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  .vtl-input {
    border: none;
    max-width: 150px;
    border-bottom: 1px solid blue;
  }

  &.vtl-active {
    outline: 2px dashed pink;
  }

  .vtl-caret {
    margin-left: -1rem;
  }

  .vtl-operation {
    margin-left: 2rem;
    letter-spacing: 1px;
  }
}

.vtl-item {
  cursor: pointer;
}

.vtl-tree-margin {
  margin-left: 2em;
}

.break {
  flex-basis: 100%;
  height: 0;
}

.options {
  font-size: 12px;
  font-style: italic;

  .edit {
    color: #0c3a9b;
  }
}

.dot {
  height: 10px;
  width: 10px;
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  transform: rotate(45deg);
  display: inline-block;
  position: absolute;
  left: -30px;
  top: 5px;

  &-filled {
    background-color: #0c5eef;
  }

  &-outline {
    border: 1px solid #0c5eef;
  }
}

.opportunity-indicator {
  &-set {
    background-color: #f26724;
  }

  padding: 6px;
  display: inline-block;
}

.evidences-indicator-green,
.evidences-indicator-yellow,
.evidences-indicator-blue,
.evidences-indicator-outline {
  position: relative;
}

.evidences-indicator-green:after {
  content: "";
  padding: 6px;
  background: #3ece0f;
  position: absolute;
  top: 2px;
  right: -20px;
  border-radius: 50%;
}

.evidences-indicator-yellow:after {
  content: "";
  padding: 6px;
  border: 1px solid #009344;
  position: absolute;
  top: 2px;
  right: -20px;
  border-radius: 50%;
}

element.style {
  background: none;
  border: 1px solid rgb(0, 162, 156);
}

.evidences-indicator-outline:after {
  content: "";
  padding: 6px;
  border: 1px solid rgb(0, 162, 156);
  position: absolute;
  top: 2px;
  right: -20px;
  border-radius: 50%;
}

.evidences-indicator-blue:after {
  content: "";
  padding: 6px;
  background: #1581f7;
  position: absolute;
  top: 2px;
  right: -20px;
  border-radius: 50%;
}

.evidence-indicator {
  color: #1e4380;
  font-style: italic;
}
.vtl-node-content {
  position: relative;
}
</style>
